window.plimo = {};
window.plimo.fusionPos = 0
window.plimo.sectionFooterPos = 0;

$(function(){
  //----------------------
  // 共通処理
  //----------------------
  // ブラウザ判定
  let broswerType = $(window).width() < 415 ? 'mobile' : 'pc';
  // localStorage.setItem('broswerType', broswerType);
  // function obsWindow() {
  //   return $(window).width() < 415 ? 'mobile' : 'pc';
  // }
  // リサイズ自動リロード
  // $(window).on('resize', function(){
  //   const type = localStorage.getItem('broswerType');
  //   if (type != obsWindow()) {
  //     location.href = location.href;
  //   }
  // });

  // スプラッシュ制御
  const splashWaitDuration = localStorage.getItem('broswerType') != '' ? 2000 : 5000;
  // $.when(
  //   $('.img_splash_001').animate({opacity: 1}, 400),
  //   $('.img_splash_002').delay(200).animate({opacity: 1}, 400),
  //   $('.img_splash_003').delay(400).animate({opacity: 1}, 400)
  // ).done(function(){
  // });
  setTimeout(function(){
    const headerHeight = $('.logo').outerHeight() + $('.slideTab:first-child').outerHeight();
    if (broswerType == 'mobile') {
      $('head').append('<style>.container .panel:not([data-tab="HOME"]) {padding-top: '+headerHeight+'px;}</style>')
    }
    window.plimo.fusionPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $('.current .blk_consultation').outerHeight(true) - $(window).height() + 58;
    window.plimo.sectionFooterPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $(window).height();

    $('.splash').animate({opacity: 0}, 1000).promise().done(function(){
      $('.splash').remove();
    });
  }, splashWaitDuration);

  // プラグイン制御
  let $slideTab = null;
  $('.js-pict_frame').pictFrame();
  $('.js-pict_frame_nothmb').pictFrame({thumbnail: false, bg: true, delayTiming: 5000});

  $.pictFrame.fade();
  // const $perspectives = $('.perspective').children();
  // const pRate = [1, 0.95, 0.5, 0.45, 0.4];

  if (broswerType == 'mobile') {
    //----------------------
    // SP用処理
    //----------------------
    // greeting 遠近処理
    // window.addEventListener('deviceorientation', function(e){
    //   if (Math.floor(e.timeStamp)%3 != 0) {
    //     return false;
    //   }
    //   // gamma スマホy軸回転
    //   // beta  スマホx軸回転
    //   const xtransrate = Math.abs(e.gamma) < 15 ? Math.floor(e.gamma) : Math.sign(e.gamma)*15;
    //   const ytransrate = Math.abs(e.beta-45) < 15 ? Math.floor(e.beta-45) : Math.sign(e.beta-45)*15;
    //   $perspectives.each(function(idx, ele){
    //     $(ele).css({transform: 'translate(' + xtransrate * pRate[idx] + 'px, ' + ytransrate * pRate[idx] + 'px)'});
    //   });
    // });

    // プラグイン実行
    $slideTab = $('.slideTabs').slideTabs();

    // スクロール処理（写真つきボタン、フッターボタン）
    // $(window).one('load', function(){
    //   window.plimo.fusionPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $('.current .blk_consultation').outerHeight(true) - $(window).height() + 58;
    //   window.plimo.sectionFooterPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $(window).height();
    //   // console.log(window.plimo.fusionPos, $('.current').innerHeight(), $('.current .section_footer').outerHeight(), $('.current .blk_consultation').outerHeight(true), $(window).height());
    // });
    // $('.slideTab').on('click', function(){
    //   setTimeout(function(){
    //     window.plimo.fusionPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $('.current .blk_consultation').outerHeight(true) - $(window).height() + 58;
    //     window.plimo.sectionFooterPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $(window).height();
    //   }, 500);
    // });
    $(window).on('scroll', function(){
      const $this = $(this);
      const scrollPos = $(this).scrollTop();
      const $fusion = $('.current .blk_fusion');
      const $sectionFooter = $('.section_footer');
      const $links = $sectionFooter.find('.inner_links');
      // console.log(scrollPos, window.plimo.sectionFooterPos);
      if (scrollPos > window.plimo.fusionPos) {
        $fusion.addClass('active');
      } else {
        $fusion.removeClass('active');
      }
      if (scrollPos > window.plimo.sectionFooterPos) {
        $links.removeClass('active');
        $links.find('.btn').addClass('btn_block');
      } else {
        $links.addClass('active');
        $links.find('.btn').removeClass('btn_block');
      }
    });

    // 写真つきボタン処理
    $('.btn_mail, .btn_photo_reserve').on('click', function(e){
      e.preventDefault();
      if ($(this).parent().hasClass('active')) {
        return false;
      }
      $slideTab.slide('contact');
      const $blkForm = $('.panel[data-tab="contact"] .blk_form');
      // const sh = $blkForm.offset().top;
      $('body, html').animate({scrollTop: 0}, 200);
    });

    // フッターボタン処理
    $('.inner_links').on('click', '.btn', function(e){
      e.preventDefault();
      const $btn = $(e.currentTarget);
      if ($btn.hasClass('btn_map')) {
        const tabName = $('.btn_slide.active').parent().attr('data-tab');
        if (tabName == 'access') {
          $('body, html').animate({ scrollTop: 0 }, 750);
        } else {
          $slideTab.slide('access');
        }
      }
    });
    $('.btn_map_detail').on('click', function(e){
      e.preventDefault();
      $slideTab.slide('access');
    })

  } else {
    //----------------------
    // PC用処理
    //----------------------
    // 初期表示時メイン画像アニメーションの実行
    // if ($(window).scrollTop() > $(window).height() / 4 && $(window).width() > 768) {
    //   $('.current .section_header').addClass('step_0 step_1');
    // } else {
    //   $('.current .section_header').removeClass('step_0 step_1 step_2');
    // }
    // if ($(window).scrollTop() > $(window).height() - $('.slideTabs').offset().top) {
    //   $('.slideTabs').addClass('negative');
    // } else {
    //   $('.slideTabs').removeClass('negative');
    // }

    // greeting 遠近処理
    // $(window).on('mousemove', function(e){
    //   const xtransrate = Math.floor(e.pageX / 50);
    //   const ytransrate = Math.floor(e.pageY / 50);
    //   $perspectives.each(function(idx, ele){
    //     $(ele).css({transform: 'translate(' + xtransrate * pRate[idx] + 'px, ' + ytransrate * pRate[idx] + 'px)'});
    //   });
    // });

    // スクロール処理（メイン画像のアニメーション実行）
    const $globalHeader = $('.header');
    const $sectionHeader = $('.current .section_header');
    const delayTime =  window.getComputedStyle($sectionHeader[0]).transitionDelay.slice(0,-1) * 1000;
    $(window).on('scroll', function(){
      const $this = $(this);
      const scrollPos = $(this).scrollTop();
      const tabPos = $('.slideTabs').offset().top;
      const isPC = $(window).width() > 768;
      const transPoint = $(window).height() / 4;
      if (scrollPos > transPoint && isPC) {
        $globalHeader.addClass('step_0');
        $sectionHeader.addClass('step_0').promise().done(function(){
          setTimeout(function(){
            $sectionHeader.addClass('step_1');
          }, delayTime);
        });
      } else if ($sectionHeader.hasClass('step_0')) {
        $globalHeader.removeClass('step_0');
        $sectionHeader.addClass('step_2').promise().done(function(){
          setTimeout(function(){
            $sectionHeader.removeClass('step_0 step_1 step_2');
          }, delayTime);
        });
      }
      if (scrollPos > $(window).height() - tabPos) {
        $('.slideTabs').addClass('negative');
        $('.pc_sticky_btns .sticky_btn:last-child').addClass('negative');
      } else {
        $('.slideTabs').removeClass('negative');
        $('.pc_sticky_btns .sticky_btn:last-child').removeClass('negative');
      }
    });

    // ページトップへの移動
    // $('.pc_sticky_btns .btn_circle').on('click', function(){
    //   $('body, html').animate({scrollTop: 0}, 500);
    // });

    // 写真つきボタン処理
    $('.btn_mail').on('click', function(e){
      e.preventDefault();
      let scrollPos = $('.panel[data-tab="contact"]').offset().top;
      $('body, html').animate({scrollTop: scrollPos}, 500);
    });

    // ページ内リンクのスムーススクロール
    $('.header').on('click', '.btn', function(e){
      const $btn = $(e.currentTarget);
      const panelName = $btn.parent().attr('data-tab');
      let scrollPos = $('.panel[data-tab="' + panelName + '"]').offset().top;
      if (panelName == 'access') {
        scrollPos -= 100;
      }
      $('body, html').animate({scrollTop: scrollPos}, 500);
    });

  }

  //----------------------
  // 共通処理
  //----------------------
  // スクロール誘導のアクション
  // $('.scroll_induction').on('click', function(){
  //   const scrollPos = $('.section_header + div').offset().top - (broswerType == 'mobile' ? $('.header').height() : 0);
  //   $('body, html').animate({scrollTop: scrollPos}, 500);
  // });

  // フォーム処理
  //  確認ボタン
  $('#confirm').on('click', function(e){
    e.preventDefault();
    const $this = $(this);
    $this.closest('.blk_form').addClass('confirm');
    const scrollPos = $('.form_flow').offset().top - (broswerType == 'mobile' ? $('.header').outerHeight() : 60);
    console.log(scrollPos);
    $('body, html').animate({scrollTop: scrollPos}, 500);
  });
  //  送信ボタン
  $('#submit').on('click', function(e){
    e.preventDefault();
    const $this = $(this);
    const $form = $this.closest('.blk_form');
    $form.find('.form_contents').append('<div class="loader">Loading...</div>');

    const data = {
      name     : $('#name').val(),
      mail     : $('#mail').val(),
      tel      : $('#tel').val(),
      message  : $('#message').val(),
      clinicmail: siteData.info.mail
    };
    // console.log(data);
    // return false;
    // console.log('fetch');
    fetch('https://s123.myssl.jp/maximum/post_mail_pai.php', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { "Content-type" : "application/x-www-form-urlencoded" }//,
      // mode: 'cors'
    }).then(function (response) {
      // console.log(response);
      return response.text();
    }).then(function(text){
      // console.log(text);
      let mailSendState = '';
      if (text == "post mail") {
        $('#name').val('');
        $('#mail').val('');
        $('#tel').val('');
        $('#message').val('');
      } else if (text == "error mail") {
        mailSendState = '<p class="fail_text">メッセージが送信できませんでした。しばらくたってからお試しください。</p>';
      }
      setTimeout(function(){
        $form.find('.loader').remove();
        if (mailSendState) {
          $form.append(mailSendState);
        } else {
          $form.addClass('submit');
          $form.find('.correct').removeClass('correct');
          $('body, html').animate({scrollTop: $('.form_flow').offset().top - $('.header').outerHeight()}, 500);
        }
      }, 2000);
    });
  });
  //  戻るボタン
  $('#back').on('click', function(){
    $(this).closest('.blk_form').removeClass('confirm');
  });
  //  home画面への切り替え
  $('#home').on('click', function(){
    $(this).closest('.blk_form').removeClass('confirm submit');
    if ($slideTab) {
      $slideTab.slide('HOME');
    }
  });
  //  input要素へのバリデーション
  $('.form_block .form_parts').on('keyup', function(){
    $('#confirm').prop('disabled', !($('.form_block').length - 1 == $('.correct').length && $(this).val()));
  })
  $('.form_block .form_parts').on('blur', function(){
    const $this = $(this);
    const $formBlock = $this.closest('.form_block');
    $formBlock.find('.form_error').remove();
    const partsName = $this.attr('name');
    const value = $this.val();
    let errFlg = false;
    let errTxt = '';
    if (['name', 'message'].indexOf(partsName) != -1) {
      errFlg = value == '';
      errTxt = '※必須項目です';
    } else if (partsName == 'mail') {
      const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      errFlg = !(reg.test(value));
      errTxt = value == '' ? '※必須項目です': '※メールアドレスの形式が間違っています。';
    } else if (partsName == 'tel') {
      const reg = /^0\d{9,10}$/;
      errFlg = !(reg.test(value));
      errTxt = value == '' ? '※必須項目です': '※電話番号をお確かめください。';
    }
    if (errFlg) {
      $formBlock.addClass('error').removeClass('correct');
      $formBlock.append('<dd class="form_error">'+errTxt+'</dd>');
    } else {
      $formBlock.removeClass('error').addClass('correct');
      $formBlock.find('.form_value').text(value);
    }
    $('#confirm').prop('disabled', !($('.form_block').length == $('.correct').length));
  });

});
